import { useEffect, useState } from 'react';
import { getAllUsers, getUser } from '../data/userService';
import { useSession } from '../context/SessionContext.jsx';

/** Fetch one user by uid. Pass null to skip fetching. */
export function useUser(uid) {
  const { dataVersion } = useSession();
  const [state, setState] = useState({ user: null, loading: !!uid });

  useEffect(() => {
    if (!uid) {
      setState({ user: null, loading: false });
      return undefined;
    }
    let live = true;
    setState((s) => ({ ...s, loading: true }));
    getUser(uid).then((user) => {
      if (live) setState({ user, loading: false });
    });
    return () => { live = false; };
  }, [uid, dataVersion]);

  return state;
}

/** Fetch every member (used for top performers and "Also held by…"). */
export function useAllUsers() {
  const { dataVersion } = useSession();
  const [state, setState] = useState({ users: [], loading: true });

  useEffect(() => {
    let live = true;
    getAllUsers().then((users) => {
      if (live) setState({ users, loading: false });
    });
    return () => { live = false; };
  }, [dataVersion]);

  return state;
}
